"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransport = void 0;
const ably_1 = require("./ably");
exports.getTransport = (config) => {
    if (config.transport === 'ABLY') {
        return ably_1.AblyTransport(config);
    }
    throw new Error(`Invalid config`);
};
